export const SET_BOTTOM_PADDING = 'SET_BOTTOM_PADDING';

export const mutations = {
    [SET_BOTTOM_PADDING](state, payload) {
        state.bottomPadding = payload;
    },
};
